module.exports = __webpack_public_path__ + "assets/img/btn_exchanged.9189ad42.png";